import React, {useState} from "react";
import {addXeroVat} from "../../utils";
import useEditableTableTextAreaCell from "../../hooks/useEditableTableTextAreaCell";
import PaymentTypePicker from "../Settings/PaymentTypes/PaymentTypePicker";
import useEditableTableCostCell from "../../hooks/useEditableTableCostCell";
import useEditableTableDateCell from "../../hooks/useEditableTableDateCell";
import TrackingOptionsPicker from "../Settings/TrackingCategory/TrackingOptionsPicker";
import TaxTypePicker from "../Settings/NominalCodes/TaxTypePicker";
import { Input, Select } from "@allxsmith/bestax-bulma";
import NominalCodePicker from "../Settings/NominalCodes/NominalCodePicker";


export default function ApproveModalRow({transaction, onChange, onSave,
                                            paymentTypes, paymentTypeObjects, index, trackingOptions, trackingOptionObjects, nominalCodes,
                                            nominalCodeObjects}){
    const [editable, setEditable] = useState(false);

     const onPaymentTypeChange = e => {
         const toUpdate = {
             target: {
                 name: e.target.name,
                 value: paymentTypeObjects[e.target.value]
             }
         }
         onChange(toUpdate, index)
     }

     const onNominalCodeChange = e => {
         const toUpdate = {
             target: {
                 name: e.target.name,
                 value: nominalCodeObjects[e.target.value]
             }
         }
         onChange(toUpdate, index)
     }

     const accountOptions = [
        { name: "", value: "BLANK"},
        { name: "Hire", value: "hire_account_code"},
        { name: "Sale", value: "sale_account_code"},
        { name: "Workshop", value: "workshop_account_code"},
        { name: "Deposit", value: "deposit_account_code"},
        { name: "Loan", value: "loan_account_code"},
        { name: "Part", value: "part_account_code"},
        { name: "Court", value: "court_account_code"},
        { name: "Movement", value: "movement_account_code"}
     ];

     // const onTransactionCategoryChange = e => {
     //     const toUpdate = {
     //         target: {
     //             name: e.target.name,
     //             value: transactionCategoryObjects[e.target.value]
     //         }
     //     }
     //     onChange(toUpdate, index)
     // }

     const handleTrackingOptionUpdate = e => {
         const toUpdate = {
            target: {
                name: e.target.name,
                value: trackingOptionObjects[e.target.value]
            }
         };
         onChange(toUpdate, index)
     };


    return (
        <tr key={transaction.id}>
            <td>{transaction.id}</td>
            {useEditableTableTextAreaCell({
               propName: "description",
                value: transaction.description,
                onChange: e => onChange(e, index),
                onSave: e => onSave(e, index, setEditable),
                editable,
                setEditable,
                disabled: false,
                inlineEdit: true,
                doubleWide: false
            })}
            <td>{transaction.contact ? transaction.contact.display_name : ""}</td>
            <td onClick={e => {
                e.stopPropagation();
            }}>
                <TrackingOptionsPicker
                  name={"tracking_option"}
                  blank={true}
                  value={transaction.tracking_option}
                  editable={editable}
                  setEditable={setEditable}
                  inlineEdit={!transaction.approved}
                  onSave={e => onSave(e, index, setEditable)}
                  onChange={handleTrackingOptionUpdate}
                  options={trackingOptions}
                  disabled={!editable || transaction.approved}
                />
            </td>
            <td>
                <PaymentTypePicker
                    options={paymentTypes}
                    editable={editable}
                    setEditable={setEditable}
                    disabled={!editable}
                    inlineEdit={false}
                    value={transaction.payment_type}
                    blank={true}
                    onSave={(e) => onSave(e, index, setEditable)}
                    onChange={onPaymentTypeChange}
                />
            </td>
            {transaction.type === "IN" &&
                <td>
                  <Select
                    name={"customer_account"}
                    disabled={!editable}
                    value={transaction.customer_account}
                    onChange={e => onChange(e, index)}
                  >
                    {accountOptions.map((option) => (
                        <option value={option.value}>{option['name']}</option>
                    ))}
                  </Select>
                </td>
            }
            <td onClick={e => e.stopPropagation()}>
                <NominalCodePicker
                    inlineEdit={false}
                    editable={editable}
                    disabled={!editable}
                    value={transaction.nominal_code}
                    onChange={onNominalCodeChange}
                    onSave={e => onSave(e, index, setEditable)}
                    name={"nominal_code"}
                    options={nominalCodes}
                    blank={true}
                />
            </td>
            {useEditableTableCostCell({
                propName: "invoice_amount",
                value: transaction.invoice_amount,
                onChange: e => onChange(e, index),
                onSave: e => onSave(e, index, setEditable),
                editable,
                setEditable,
                disabled: false,
                inlineEdit: false
            })}
            <td>
                <TaxTypePicker
                    value={transaction.invoice_vat}
                    name={"invoice_vat"}
                    onChange={(e) => onChange(e, index)}
                    disabled={!editable}
                />
            </td>
            <td>£{addXeroVat(transaction.invoice_vat, transaction.invoice_amount)}</td>
            {transaction.type === "IN" &&
                <td>
                    <Input
                        name={"customer_paid_amount"}
                        value={transaction.customer_paid_amount}
                        onChange={e => onChange(e, index)}
                        disabled={!editable}
                    />
                </td>
            }
            {useEditableTableDateCell({
                propName: "invoice_date",
                value: transaction.invoice_date,
                onChange: e => onChange(e, index),
                onSave: e => onSave(e, index, setEditable),
                editable,
                setEditable,
                disabled: false,
                inlineEdit: false,
                monthOnly: false
            })}
        </tr>
    );
}